module.exports = __webpack_public_path__ + "static/media/Inter-Light-BETA.5f9d6b27.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Light-BETA.woff2
// module id = 694
// module chunks = 21